import { WizardStateController } from './wizard-state.controller';
import { WizardStateComponentProps } from './wizard-state.model';

const WizardState = (props: WizardStateComponentProps): JSX.Element => {
  return <WizardStateController {...props} />;
};
export default WizardState;
